// Runtime staleness tripwire.
//
// TAK-16: returning visitors ran a weeks-old build for days because a stale
// service worker kept serving the old cached app, and nothing in the app
// could tell. This check compares the hashed main bundle this page is
// running with the one the server currently deploys; on mismatch it clears
// caches, unregisters any service worker and reloads once — the same
// recovery as the public/service-worker.js kill-switch, but triggered by
// the app itself instead of the worker update path.
//
// No-op in development (no hashed main bundle) and whenever the server
// cannot be reached: it must never block or break startup.

const RELOADED_FLAG = 'build-check-reloaded'

function ownMainBundle() {
	const script = document.querySelector('script[src*="/static/js/main."]')
	return script ? script.getAttribute('src') : null
}

async function deployedMainBundle() {
	// The cache-busting query keeps the request out of service-worker precache
	// manifests and CDN caches, so a future zombie worker cannot serve a stale
	// answer here — that is exactly the state this check exists to detect.
	const response = await fetch(`/?build-check=${Date.now()}`, { cache: 'no-store' })
	if (!response.ok) return null
	const html = await response.text()
	const match = html.match(/\/static\/js\/main\.[0-9a-f]+\.js/)
	return match ? match[0] : null
}

export async function checkForStaleBundle() {
	try {
		const own = ownMainBundle()
		if (!own) return
		const deployed = await deployedMainBundle()
		if (!deployed) return
		if (own.endsWith(deployed)) return
		if (sessionStorage.getItem(RELOADED_FLAG)) {
			console.warn(`[build-check] still stale after reload (running ${own}, deployed ${deployed})`)
			return
		}
		console.warn(`[build-check] stale bundle detected (running ${own}, deployed ${deployed}) — clearing caches and reloading`)
		sessionStorage.setItem(RELOADED_FLAG, '1')
		if ('caches' in window) {
			const names = await caches.keys()
			await Promise.all(names.map((name) => caches.delete(name)))
		}
		if ('serviceWorker' in navigator) {
			const registrations = await navigator.serviceWorker.getRegistrations()
			await Promise.all(registrations.map((registration) => registration.unregister()))
		}
		window.location.reload()
	} catch (error) {
		console.warn('[build-check] skipped:', error)
	}
}
